import { Fab, withStyles } from "@material-ui/core";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";

import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as GoogleMapIcon } from "../../assets/images/icons/google-maps.svg";

import styles from "./styles";

import { Canvas, Header, Logo, Search, Sidebar,MediaBar } from "../../components";

import { Wrapper } from "../index";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { filters, helpers } from "../../store";
import { version, ui } from "../../config";


import { Filter } from "../../components/";

const Layout = props => {
	const { classes, opened, hidden, filtersList, list } = props;

	const item = list[1];

	return (
		<Wrapper id="layout" className={classes.wrapper}>
			<main className={classes.main}>
				<Canvas />
				<div className={classes.legend}>
					<table>
						<tbody style={{textAlign: "left"}}>
							<tr>
								<td bgcolor={"#648fea"} width={"0.8rem"}></td><td>Bureaux</td>
							</tr>
							<tr>
								<td bgcolor={"#fad645"} width={"10px"}></td><td>Commerces</td>
							</tr>
							<tr>
								<td bgcolor={"#ff537b"} width={"10px"}></td><td>Services</td>
							</tr>
						</tbody>
					</table>
				</div>
				<MediaBar />
				<div
					className={classNames(classes.sliderCanvas)}
					variant="extended"
				>
					<img src={"assets/images/logo-Aura.png"} className={classes.interPNG} alt={"aura"}/>
					<Filter item={item} />
				</div>
				{!version.office || !version.districtMode ? (
					<>
						{/* <Fab
							className={classNames(classes.btnBack)}
							variant="extended"
						>
							<CanvasButton />
						</Fab> */}
					</>


				) : (<></>)}
			</main>
		</Wrapper>
	);
};

const mapStateToProps = state => ({
	filtersList: {
		...state.filters[state.helpers.building]
	},
	list: {
		...state.settings[state.helpers.building].filters
	},
	...state.helpers
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			handleOpenSearch: helpers.openSearch,
			handleOpenMedia: helpers.openMedia,
			type: filters.setType,
			floor: filters.setFloor,
			benefit: filters.setBenefit,
			price: filters.setPrice,
			surface: filters.setSurface
		},
		dispatch
	);

Layout.propTypes = {
	classes: PropTypes.object.isRequired,
	lights: PropTypes.bool,
	toggleLights: PropTypes.func,
	filtersList: PropTypes.object.isRequired,
};

Layout.defaultProps = {
	lights: false,
	toggleLights: () => false
};

export default withStyles(styles)(
	connect(mapStateToProps, mapDispatchToProps)(Layout)
);
